import { useSelector } from "react-redux";
import { extractValue } from "./utils";

export const useClientFirstName = () => {
  const { clientData } = useSelector((state) => state.Client);

  return extractValue(clientData, "firstName");
};